import { render } from "./SettingsWizard.vue?vue&type=template&id=607bd209&scoped=true"
import script from "./SettingsWizard.vue?vue&type=script&lang=js"
export * from "./SettingsWizard.vue?vue&type=script&lang=js"

import "./SettingsWizard.vue?vue&type=style&index=0&id=607bd209&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607bd209"]])

export default __exports__